import checkMarkTealImg from "assets/checkmark_teal.svg";
import exCrossImg from "assets/mfi_post_ex_cross.svg";
import React, { Component } from "react";
import { strings } from "../../../constants/strings";
import Variants from './Variants'

import { CSSTransition } from "react-transition-group";

export default class Questions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentQuestionIndex: props.currentQuestionIndex,
      questions: props.questions,
      showAnswerRight: props.showAnswerRight,
      answerKey: props.answerKey
    }
  }
  render() {
    let questionLbl = strings.PowerReader_lbl_questions;
    questionLbl = questionLbl.split("%d");
    return (
      <div className="question-container">
        <div 
        className="question-head"
        dangerouslySetInnerHTML={{__html: questionLbl[0] + (this.props.currentQuestionIndex + 1) + questionLbl[1]}}
        >
        </div>
        <div style={
          {
            minHeight: '48px'
          }
        }>
        <CSSTransition
          in={!this.props.nextQuestion}
          timeout={400}
          classNames='opacity-transition'
          mountOnEnter
          unmountOnExit
          onExited={() => {
            this.setState({ currentQuestionIndex: this.props.currentQuestionIndex})
          }}
        >
          <div className='question-test'>{this.state.questions[this.state.currentQuestionIndex].title}</div>
        </CSSTransition>
        
        </div>
        <div 
        className="question-head" 
        style={{ marginTop: 10 }} 
        dangerouslySetInnerHTML={{__html: strings.PowerReader_lbl_answer}}
        >
        </div>
        <div className='variants-container'>
          <CSSTransition
            in={!this.props.nextQuestion}
            timeout={400}
            classNames='opacity-transition'
            mountOnEnter
            unmountOnExit
            onExited = {()=>{
              this.props.questionSwitched()}}
          >
            <Variants
              questions = {this.state.questions}
              currentQuestionIndex = {this.state.currentQuestionIndex}
              showAnswerRight = {this.props.showAnswerRight}
              answerKey = {this.props.answerKey}
              onAnswerClick = {this.props.onAnswerClick}
            />
          </CSSTransition>
        </div>
      </div>
    );
  }
}
